import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
	AudienceActions,
	AudienceTable,
	useAudience,
} from "@di-devs/audience-feature-plugin/client";
import type { AudienceWithStatus } from "@di-devs/audience-feature-plugin/shared";
import { useBetterFeatureClient } from "@di-devs/utils-fe";
import type { TableColumnsType } from "antd";
import { Modal, message } from "antd";
import { type FC, useCallback } from "react";
import type { FeatureClient } from "@/config/client";
import { useListMemberAttributes } from "@/queries/memberAttributes.queries";
import { getMemberColumns } from "./columns";

const MemberAudienceTab: FC = () => {
	const client = useBetterFeatureClient<FeatureClient>();
	const [modal, contextHolder] = Modal.useModal();

	const {
		publicSettings,
		hooks: { audiencesQuery, deleteAudienceMutation },
	} = useAudience({
		type: "member",
	});

	// Fetch member attributes for the table columns
	const { data: memberAttributesResponse } = useListMemberAttributes(client);
	const memberAttributes = (memberAttributesResponse as any)?.data?.data || [];

	const handleDelete = useCallback(
		(record: AudienceWithStatus) => {
			modal.confirm({
				title: "確認",
				icon: <ExclamationCircleOutlined className="text-red-600" />,
				content: (
					<div>
						<p className="mb-2">
							以下のオーディエンスを削除してもよろしいですか？
						</p>
						<p className="text-red-600 font-semibold">
							{record.description || "ー"}
						</p>
						<p className="text-sm text-gray-500 mt-2">
							この操作は元に戻すことができません。
						</p>
					</div>
				),
				okText: "削除",
				okButtonProps: {
					type: "primary",
					danger: true,
				},
				cancelText: "キャンセル",
				centered: true,
				async onOk() {
					try {
						await deleteAudienceMutation.mutateAsync(record.audienceGroupId);
						message.success("オーディエンスを削除しました");
					} catch (error) {
						message.error("削除に失敗しました");
						console.error("Delete error:", error);
					}
				},
			});
		},
		[modal, deleteAudienceMutation],
	);

	const columns: TableColumnsType<AudienceWithStatus> = getMemberColumns({
		memberAttributes,
		onDelete: handleDelete,
		publicSettings,
	});

	return (
		<div className="member-audience-container">
			<AudienceActions />

			<AudienceTable<AudienceWithStatus>
				data={(audiencesQuery.data as any)?.data || []}
				columns={columns}
				rowKey="audienceGroupId"
				emptyText="会員証オーディエンスのデータがありません"
				pagination={{
					showSizeChanger: false,
				}}
			/>

			{contextHolder}
		</div>
	);
};

export default MemberAudienceTab;
